import { COLOR } from 'admin/constants/styles';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 85vh;
  width: 100%;
`;

const Alert = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5vh;
  width: 35%;
  background-color: ${COLOR.alert};
  border: 1px solid ${COLOR.errorMessage};
  border-radius: 5px;
  padding: 1em;
`;

const AlertHeader = styled.h3`
  color: ${COLOR.errorMessage};
  font-size: 1.25em;
  font-weight: bold;
`;

const AlertMessage = styled.p`
  color: ${COLOR.errorMessage};
`;

const PageCrashErrorAlert = () => {
  return (
    <Wrapper>
      <Alert>
        <AlertHeader>予期しないエラーが発生しました。</AlertHeader>
        <AlertMessage>お手数ですが、時間をおいて再度お試し下さい。</AlertMessage>
      </Alert>
    </Wrapper>
  );
};

export default PageCrashErrorAlert;
